import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'
import type { AthleticsTeamSchedule } from '@/types/enrollments'

// GET /ajax/athletics/{enrollmentId}/schedule (DTA-799 round 5: read from the
// team profile document, no slot reads)
//
// A 403 here means the team's "share schedule" switch is off, not that the
// session died — so the auth redirect is suppressed and the caller shows the
// server's failure_reason instead.
export const athleticsTeamSchedule = async (
  enrollmentId: number
): Promise<AthleticsTeamSchedule> => {
  const response = await new Request(undefined, 'json', { redirectOnForbidden: false }).get(
    '/ajax/athletics/' + enrollmentId + '/schedule'
  )
  return Util.Obj.keysToCamel({
    team: response.data.team,
    sessions: response.data.sessions ?? []
  }) as AthleticsTeamSchedule
}
